import Big from 'big.js'
import { dates } from '@homevest/utils'

export const canonicalAmount = (amount: string | number) => new Big(amount).toString()

export const canonicalDate = (date: string | Date) => dates.normalizeToDateString(date)

export const canonicalLiabilityKey = ({
  amount,
  date,
  liabilityTypeId,
  rentalId
}: {
  amount: string | number
  date: string
  liabilityTypeId: string
  rentalId: string
}) => [rentalId, liabilityTypeId, canonicalDate(date), canonicalAmount(amount)].join('|')
